const MODULE_NAME = 'fulcrum/containers/Redirect'
const REDUCER_PATH = 'redirect'

// actions
const PUSH = 'fulcrum/containers/Redirect/PUSH'
const PUSH_START = 'fulcrum/containers/Redirect/PUSH_START'
const PUSH_SUCCESS = 'fulcrum/containers/Redirect/PUSH_SUCCESS'

//reducer
const UPDATE_TO = 'fulcrum/containers/Redirect/UPDATE_TO'
const UPDATE_REDIRECT = 'fulcrum/containers/Redirect/UPDATE_REDIRECT'

export {
  PUSH,
  PUSH_START,
  PUSH_SUCCESS,
  UPDATE_TO,
  UPDATE_REDIRECT,
  REDUCER_PATH,
  MODULE_NAME,
}
